import * as React from "react";
import {useEffect, useState} from "react";
import {createRoot} from "react-dom/client";
import {loadBlogs} from "../../helpers/loadBlogs";

type SubNavItemType = {
  headline: string;
  image: string;
  link: string;
};

class SubNavImageLinkPortal {
  public static run() {
    const subNavItemDiv = document.getElementById("NavRecentBlogEntry") as HTMLElement | undefined;

    if (!subNavItemDiv || !SubNavImageLink) {
      return;
    }

    const root = createRoot(subNavItemDiv);
    root.render(<SubNavImageLink />);
  }
}

export default SubNavImageLinkPortal;

// Most recent blog entry as dynamic subnav-aside item for 'Inspiration' submenu (DE only)
const SubNavImageLink: React.FC = () => {
  const [content, setContent] = useState<SubNavItemType>();

  useEffect(() => {
    void loadBlogs().then((blogs) => {
      if (!blogs.length) return;

      setContent({image: blogs[0].image, headline: blogs[0].headline, link: blogs[0].link});
    });
  }, []);

  if (content === undefined || content.image === undefined) {
    return null;
  }

  return (
    <a href={content.link} className="subnav-aside__item" title={content.headline}>
      <div className="subnav-aside__image">
        <img src={content.image} alt="" loading="lazy" />
      </div>
      <div className="subnav-aside__text">
        <span className="subnav-aside__subtitle">Blogbeitrag der Woche</span>
        <span className="line-clamp-two">{content.headline}</span>
      </div>
    </a>
  );
};
